import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getBookingHref } from '../lib/cal';

const SECTIONS = ['intro', 'ventures', 'now', 'writing', 'contact'] as const;
type Section = (typeof SECTIONS)[number];

export function Nav() {
  const [active, setActive] = useState<Section>('intro');
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  const onClick = (s: Section) => (e: React.MouseEvent) => {
    e.preventDefault();
    setActive(s);
    if (!isHome) {
      // From a subroute, go home and let the hash take us to the section.
      navigate(`/#section-${s}`);
      return;
    }
    const el = document.getElementById(`section-${s}`);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav
      className="nav"
      style={{
        borderBottom: '1px solid var(--ink)',
        position: 'relative',
        zIndex: 2,
      }}
    >
      <div
        className="nav-inner"
        style={{
          display: 'flex',
          gap: 24,
          padding: '10px 28px',
          fontSize: 11,
          textTransform: 'uppercase',
          letterSpacing: 0.6,
          alignItems: 'center',
        }}
      >
        {SECTIONS.map((s, i) => (
          <a
            key={s}
            href={`#section-${s}`}
            onClick={onClick(s)}
            style={{
              cursor: 'pointer',
              color: active === s ? 'var(--accent)' : 'var(--ink)',
              textDecoration: active === s ? 'underline' : 'none',
            }}
          >
            <span style={{ opacity: 0.5, marginRight: 6 }}>
              {String(i + 1).padStart(2, '0')}
            </span>
            {s}
          </a>
        ))}
        <div style={{ flex: 1 }} />
        <a
          className="nav-cta"
          href={getBookingHref()}
          target="_blank"
          rel="noreferrer"
          style={{ fontWeight: 600, color: 'var(--accent)', cursor: 'pointer' }}
        >
          ▸ book a meeting
        </a>
      </div>
    </nav>
  );
}
